<template>
  <v-data-table
    :headers="headers"
    :items="referencias"
    class="transparent ui-module-fade-in-up"
    :options="{ page: false }"
    :hide-default-footer="true"
    calculate-widths
  >
    <template v-slot:[`item.direccion`]="{ item }">
      <section>
        {{
          `${item.calle} ${item.interior ?? 'S/N'} entre calles ${item.entrecalles} y ${item.entrecalles2}, ${
            item.colonia
          }, ${item.localidad},`
        }}
      </section>
      <section v-if="item.municipio && item.estado">
        {{ `${item.municipio}, ${item.estado} CP #${item.cp}` }}
      </section>
      <section v-if="item.referencias">Referencia: {{ item.referencias }}</section>
    </template>
    <template v-slot:[`item.opciones`]="{ item }">
      <span class="d-flex align-center">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <span v-bind="attrs" v-on="on">
              <IconButton class="mr-2" icon="mdi-pencil" variant="primary" @click="$emit('edit', item)" />
            </span>
          </template>
          <span>Editar Referencia</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <span v-bind="attrs" v-on="on">
              <IconButton icon="mdi-delete" variant="error" @click="$emit('delete', item)" />
            </span>
          </template>
          <span>Eliminar Referencia</span>
        </v-tooltip>
      </span>
    </template>
  </v-data-table>
</template>

<script>
import IconButton from '../base/IconButton.vue'

export default {
  components: { IconButton },

  props: {
    referencias: {
      type: Array,
      required: true,
    },

    type: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      personalHeaders: [
        { text: 'Nombre', value: 'nombre' },
        { text: 'Teléfono', value: 'telefono' },
        {
          text: 'Años de conocerlo',
          value: 'tiempoConocerse',
          align: 'right',
        },
        { text: '¿Cómo lo conoció?', value: 'comoConocio', align: 'right' },
        { text: 'Opciones', value: 'opciones' },
      ],

      laboralHeaders: [
        { text: 'Nombre', value: 'nombre' },
        { text: 'Teléfono', value: 'telefono' },
        { text: 'Tipo', value: 'tipo' },
        { text: 'Cargo', value: 'cargo' },
        { text: 'Corporación, Institución o Empresa', value: 'corporacion' },
        { text: 'Tiempo laborado (años)', value: 'tiempoLaborado', align: 'right' },
        { text: 'Opciones', value: 'opciones' },
      ],

      vecinalHeaders: [
        { text: 'Nombre', value: 'nombre' },
        { text: 'Teléfono', value: 'telefono' },
        { text: 'Tiempo de ser vecinos (años)', value: 'tiempoConocerse', align: 'right' },
        { text: 'Dirección', value: 'direccion' },
        { text: 'Opciones', value: 'opciones' },
      ],
    }
  },

  computed: {
    headers() {
      if (this.type === 'laboral') return this.laboralHeaders
      if (this.type === 'vecinal') return this.vecinalHeaders

      return this.personalHeaders
    },
  },
}
</script>

<style scoped>
/* Estilos modernos para ReferenciasTable - Adaptable a módulos */
::v-deep .v-data-table {
  background: transparent !important;
  color: #e0e0e0 !important;
  border-radius: 10px;
}

/* Encabezados de tabla - usa el color secondary del tema actual */
::v-deep .v-data-table-header {
  position: relative;
  height: 30px !important;
}

::v-deep .v-data-table-header::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: var(--v-secondary-base);
  opacity: 0.15;
  pointer-events: none;
}

::v-deep .v-data-table-header th {
  color: var(--v-secondary-base) !important;
  font-weight: 700 !important;
  font-size: 0.875rem !important;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  border-bottom: 2px solid var(--v-secondary-base) !important;
  padding: 12px 16px !important;
  height: 48px !important;
  position: relative;
  z-index: 1;
}

/* Filas de la tabla */
::v-deep .v-data-table tbody tr {
  transition: all 0.3s ease;
  border-radius: 8px;
  position: relative;
}

::v-deep .v-data-table tbody tr::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: var(--v-secondary-base);
  opacity: 0;
  transition: opacity 0.3s ease;
  pointer-events: none;
  border-radius: 8px;
}

::v-deep .v-data-table tbody tr:hover::before {
  opacity: 0.1;
}

::v-deep .v-data-table tbody tr:hover {
  transform: scale(1.005);
}

::v-deep .v-data-table tbody td {
  color: #e0e0e0 !important;
  border-bottom: 1px solid var(--v-secondary-base) !important;
  padding: 16px !important;
  position: relative;
  z-index: 1;
}

/* Empty state */
::v-deep .v-data-table__empty-wrapper {
  color: rgba(224, 224, 224, 0.6) !important;
}

/* Botones en la tabla */
::v-deep .v-btn {
  border-radius: 12px !important;
  transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275) !important;
  position: relative;
  overflow: hidden;
}

::v-deep .v-btn::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 0;
  height: 0;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.2);
  transform: translate(-50%, -50%);
  transition: width 0.6s, height 0.6s;
  pointer-events: none;
}

::v-deep .v-btn:active::before {
  width: 300px;
  height: 300px;
}

::v-deep .v-btn:hover:not(:disabled) {
  transform: translateY(-2px);
}

::v-deep .v-btn .v-icon {
  transition: all 0.3s ease;
}

::v-deep .v-btn:hover .v-icon {
  transform: scale(1.2);
}

/* Tooltips */
::v-deep .v-tooltip__content {
  background: rgba(26, 46, 36, 0.95) !important;
  backdrop-filter: blur(10px);
  border: 1px solid var(--v-secondary-base) !important;
  border-radius: 8px;
  color: #e0e0e0 !important;
  font-weight: 500;
  padding: 8px 12px;
}

/* Data footer */
::v-deep .v-data-footer {
  background: rgba(18, 18, 18, 0.5) !important;
  border-top: 1px solid var(--v-secondary-base) !important;
  color: #e0e0e0 !important;
}

::v-deep .v-data-footer__select .v-select {
  color: #e0e0e0 !important;
}

::v-deep .v-data-footer__pagination {
  color: #e0e0e0 !important;
}

/* Scrollbar - usa el color del módulo actual */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: rgba(10, 10, 10, 0.5);
  border-radius: 4px;
}

::-webkit-scrollbar-thumb {
  background: var(--v-secondary-base);
  border-radius: 4px;
  transition: all 0.3s;
}

::-webkit-scrollbar-thumb:hover {
  filter: brightness(1.2);
}
</style>
